<template>
    <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <ProgressToast v-for="toast in toasts" :titulo="toast.title" :body="toast.body" :started_at="toast.started_at"></ProgressToast>
    </div>
</template>
<script setup lang="ts">
import { processando } from '@/store/inventario-arquivos';
import { computed } from 'vue';
import ProgressToast from './ProgressToast.vue';


const toasts = computed(() => {
    let rows: { title: string, body: string, started_at: Date}[] = [];
    for (let row of processando.value.values()) {
        let progresso = Math.round(row.processed * 100 / row.total)
        
        rows.push({
            title: row.tipo,
            body: `${row.status}: ${progresso}% (${row.processed}/${row.total})`,
            started_at: row.created_at
        })
    }
    return rows
})


</script>